import * as Firebase from 'firebase/app';
import { initializeApp } from 'firebase';
import { Reference } from 'firebase/database'
import 'firebase/auth';
import 'firebase/database';

let config = {
    apiKey: "AIzaSyC0uFapj7A6-IKhz8Ylp6W_bE2vOkXSn5Y",
    authDomain: "joyevents.firebaseapp.com",
    databaseURL: "https://joyevents.firebaseio.com",
    projectId: "firebase-joyevents",
    storageBucket: "firebase-joyevents.appspot.com",
    messagingSenderId: "306430659761"
  };
  
export interface Connection {
    android: any;
    ios: any;
    web: any;
    prefixes: Array<string>;
    token?: string;
    tokenV2?: string;
    type: string;
    secret?: string;
}

let firebaseUniqueID = 0;
export const connectToDb = (conn: Connection): Promise<Reference> => {
            // This will get the config from firebae or default to the one hardcoded above
            config = conn.web ? conn.web : config;
            let token = conn.secret || conn.tokenV2;
            let prefixes = conn.prefixes.slice();
            let fbDomain = prefixes.shift();
            let uniqueAppName = `${fbDomain}`;
            if (prefixes.length) {
                const lastPrefix = prefixes[prefixes.length - 1];
                const lastCharacter = lastPrefix[lastPrefix.length - 1];
                uniqueAppName = [uniqueAppName, lastCharacter].join('/');
            }
            const fbApp = Firebase.apps.find(app => app.name === uniqueAppName) || Firebase.initializeApp(config, uniqueAppName);
            return fbApp.auth().signInWithCustomToken(token)
                .then(() => {
                   return prefixes.reduce((acc, curr) => {return acc.child(curr);}, fbApp.database().ref());
                });
};
